const config = {
  development: {
    ALQ_URL: 'https://sand-alq.ixn.io/',
    AQ_URL: 'https://sand-aq.ixn.io/',
    UQ_URL: 'https://sand-uq.ixn.io/',
    FORM_ENGINE_URL: 'https://sand-forms.ixn.io/',
    LTC_URL: 'https://sand-ltc.ixn.io/',
    WQ_URL: 'https://sand-wq.ixn.io/',
    LIFEDX_EMBED_URL: 'https://sand-embed.thelifedx.com',
    HA_ADMIN_URL:
      'https://healthanalyzer-ai-test-app-fedtauhnbkhbbybu.northcentralus-01.azurewebsites.net/',
    IRONSIDES_URL: 'https://sand-ironsides.ixn.io/',
    HORNET_URL: 'https://sand-hornet.ixn.io/',
    MANIFESTS_URL: 'https://sand-compass.ixn.io/v1/',
    LIFEDX_TOKEN: '0267a466-84ba-42d5-b025-3948a16287fd',

    RECAPTCHA_SITE_KEY: '6LfDjL8eAAAAAATXg11qxFnXeOBE0T6rKQmJjQnF',

    PostHogKey: 'phc_hsXtGzGiXYnCIlyOXsMQP3ejvfvA6QilS04MjC1WKpv',

    ANICO_CARRIER_ID: 36,
    CENTRIAN_CARRIER_ID: 186,
    LIBERTY_MUTUAL_CARRIER_ID: 1804,
    NMB_CARRIER_ID: 1800,
    PACLIFE_CARRIER_ID: 99,
    PROTECTIVE_CARRIER_ID: 69,
    SBLI_CARRIER_ID: 193
  },

  sand: {
    ALQ_URL: 'https://sand-alq.ixn.io/',
    AQ_URL: 'https://sand-aq.ixn.io/',
    UQ_URL: 'https://sand-uq.ixn.io/',
    FORM_ENGINE_URL: 'https://sand-forms.ixn.io/',
    LTC_URL: 'https://sand-ltc.ixn.io/',
    WQ_URL: 'https://sand-wq.ixn.io/',
    LIFEDX_EMBED_URL: 'https://sand-embed.thelifedx.com',
    HA_ADMIN_URL:
      'https://healthanalyzer-ai-test-app-fedtauhnbkhbbybu.northcentralus-01.azurewebsites.net/',

    IRONSIDES_URL: 'https://sand-ironsides.ixn.io/',
    HORNET_URL: 'https://sand-hornet.ixn.io/',
    MANIFESTS_URL: 'https://sand-compass.ixn.io/v1/',
    LIFEDX_TOKEN: '0267a466-84ba-42d5-b025-3948a16287fd',

    RECAPTCHA_SITE_KEY: '6LfDjL8eAAAAAATXg11qxFnXeOBE0T6rKQmJjQnF',

    PostHogKey: 'phc_hsXtGzGiXYnCIlyOXsMQP3ejvfvA6QilS04MjC1WKpv',

    ANICO_CARRIER_ID: 36,
    CENTRIAN_CARRIER_ID: 186,
    LIBERTY_MUTUAL_CARRIER_ID: 1804,
    NMB_CARRIER_ID: 1800,
    PACLIFE_CARRIER_ID: 99,
    PROTECTIVE_CARRIER_ID: 69,
    SBLI_CARRIER_ID: 193
  },
  qa: {
    ALQ_URL: 'https://qa-alq.ixn.io/',
    AQ_URL: 'https://qa-aq.ixn.io/',
    UQ_URL: 'https://qa-uq.ixn.io/',
    FORM_ENGINE_URL: 'https://qa-forms.ixn.io/',
    LTC_URL: 'https://qa-ltc.ixn.io/',
    WQ_URL: 'https://qa-wq.ixn.io/',
    LIFEDX_EMBED_URL: 'https://qa-embed.thelifedx.com',
    HA_ADMIN_URL:
      'https://healthanalyzer-ai-test-app-fedtauhnbkhbbybu.northcentralus-01.azurewebsites.net/',
    IRONSIDES_URL: 'https://qa-ironsides.ixn.io/',
    HORNET_URL: 'https://qa-hornet.ixn.io/',
    MANIFESTS_URL: 'https://qa-compass.ixn.io/v1/',
    LIFEDX_TOKEN: '0267a466-84ba-42d5-b025-3948a16287fd',

    RECAPTCHA_SITE_KEY: '6LfDjL8eAAAAAATXg11qxFnXeOBE0T6rKQmJjQnF',

    ANICO_CARRIER_ID: 36,
    CENTRIAN_CARRIER_ID: 186,
    LIBERTY_MUTUAL_CARRIER_ID: 1804,
    NMB_CARRIER_ID: 1800,
    PACLIFE_CARRIER_ID: 99,
    PROTECTIVE_CARRIER_ID: 69,
    SBLI_CARRIER_ID: 193
  },
  uat: {
    ALQ_URL: 'https://uat-alq.ixn.io/',
    AQ_URL: 'https://uat-aq.ixn.io/',
    UQ_URL: 'https://uat-uq.ixn.io/',
    FORM_ENGINE_URL: 'https://uat-forms.ixn.io/',
    LTC_URL: 'https://uat-ltc.ixn.io/',
    WQ_URL: 'https://uat-wq.ixn.io/',
    LIFEDX_EMBED_URL: 'https://uat-embed.thelifedx.com',
    HA_ADMIN_URL:
      'https://healthanalyzer-ai-test-app-fedtauhnbkhbbybu.northcentralus-01.azurewebsites.net/',
    IRONSIDES_URL: 'https://uat-ironsides.ixn.io/',
    HORNET_URL: 'https://uat-hornet.ixn.io/',
    MANIFESTS_URL: 'https://uat-compass.ixn.io/v1/',
    LIFEDX_TOKEN: '0267a466-84ba-42d5-b025-3948a16287fd',

    RECAPTCHA_SITE_KEY: '6LfDjL8eAAAAAATXg11qxFnXeOBE0T6rKQmJjQnF',

    ANICO_CARRIER_ID: 36,
    CENTRIAN_CARRIER_ID: 186,
    LIBERTY_MUTUAL_CARRIER_ID: 1804,
    NMB_CARRIER_ID: 1800,
    PACLIFE_CARRIER_ID: 99,
    PROTECTIVE_CARRIER_ID: 69,
    SBLI_CARRIER_ID: 193
  },

  production: {
    ALQ_URL: 'https://alq.ixn.io/',
    AQ_URL: 'https://aq.ixn.io/',
    UQ_URL: 'https://uq.ixn.io/',
    FORM_ENGINE_URL: 'https://forms.ixn.io/',
    LTC_URL: 'https://ltc.ixn.io/',
    WQ_URL: 'https://wq.ixn.io/',
    LIFEDX_EMBED_URL: 'https://embed.thelifedx.com',
    HA_ADMIN_URL: 'https://healthanalyzerai.hexure.com/',
    IRONSIDES_URL: 'https://ironsides.ixn.io/',
    HORNET_URL: 'https://hornet.ixn.io/',
    MANIFESTS_URL: 'https://compass.ixn.io/v1/',
    LIFEDX_TOKEN: '0267a466-84ba-42d5-b025-3948a16287fd',

    RECAPTCHA_SITE_KEY: '6LfOjL8eAAAAAM_H4-iMnpvAt-VZD8WVrKSPi00E',

    PostHogKey: 'phc_hsXtGzGiXYnCIlyOXsMQP3ejvfvA6QilS04MjC1WKpv',

    ANICO_CARRIER_ID: 36,
    CENTRIAN_CARRIER_ID: 186,
    LIBERTY_MUTUAL_CARRIER_ID: 1804,
    NMB_CARRIER_ID: 1800,
    PACLIFE_CARRIER_ID: 99,
    PROTECTIVE_CARRIER_ID: 69,
    SBLI_CARRIER_ID: 193
  }
};

module.exports = config[process.env.NODE_ENV || 'development'];
